import * as React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import {bindActionCreators} from 'redux';
import {push} from 'react-router-redux';
import {actions as quoteActions} from '../../../../services/quote/reducer';
import {IQuoteActions} from '../../../../services/quote/models';
import {Email} from '../../../../components/Email';
import {RCPStrengths} from '../../../../components/RCPStrengths';
import {getLogo} from '../../../../util/helpers';

interface IPageProps {
  actions: {
    quote: IQuoteActions;
    push: (route: string) => void;
  };
}

const URL1 = 'https://www.msamlin.com/en/site-services/data-privacy-notice/' +
  'avis-de-la-protection-des-donnees-des-clients.html';
const URL2 = 'https://www.msamlin.com/en/markets/France.html';
const URL3 = 'https://www.legifrance.gouv.fr/' +
  'affichCode.do;jsessionid=B90D33BA37BE37ED313BA94505259243.tplgfr27s_2' +
  '?idSectionTA=LEGISCTA000022962856&cidTexte=LEGITEXT000006072026&dateTexte=20180830';
const URL4 = 'https://www.legifrance.gouv.fr/affichCode.do' +
  ';jsessionid=B90D33BA37BE37ED313BA94505259243.tplgfr27s_2' +
  '?idSectionTA=LEGISCTA000006187331&cidTexte=LEGITEXT000006073984&dateTexte=20180830';

class Faq extends React.Component<IPageProps> {

  private ercproEmail() {
    return (
      <Email email={'rcpro.france@msamlin.com'}/>
    );
  }

  private indemnisationEmail() {
    return (
      <Email email={'indemnisation.france@msamlin.com'}/>
    );
  }

  private dateProtectionOfficerEmail() {
    return (
      <Email email={'dataprotectionofficer@msamlin.com'}/>
    );
  }

  public render() {
    return (
      <div className="container content-page">
        <Row>
          <Col sm={12}>
            <h2>Foire Aux Questions</h2>

            <h3>A qui s'adresse <img width={120} src={getLogo()}/>?</h3>
            <p>
              Notre plateforme de souscription en ligne s’adresse aux :
            </p>
            <ul>
              <li>Intermédiaires en Assurance</li>
              <li>Intermédiaires en Opérations de Banque et Services de Paiement</li>
              <li>Démarcheurs Bancaire et Financier</li>
              <li>Agents Commerciaux Immobilier à titre d’activité unique</li>
            </ul>
            <p>
              réalisant un chiffre d’affaires annuel allant jusqu’à 750.000 €.
            </p>
            <p>
              Au-delà de ce chiffre d’affaires, notre équipe vous accompagnera.
              N’hésitez pas à nous contacter au 01 44 70 71 00 ou nous adresser un mail à {this.ercproEmail()}
            </p>

            <h3>Pourquoi compléter notre questionnaire ?</h3>
            <p>
              Les informations demandées nous permettent d’identifier vos besoins et
              de vous adresser notre meilleure proposition.
            </p>
            <p>
              Nous vous rappelons que la proposition est établie sur la base de vos réponses.
              Toute erreur ou omission de votre part peut conduire à un refus de garantie total ou partiel.
            </p>

            <h3>Avez-vous besoin de souscrire une garantie financière ?</h3>
            <p>
              La garantie financière est obligatoire pour tout intermédiaire d’assurance et intermédiaire en
              opérations de banque et en services de paiement qui encaisse des
              fonds pour le compte de ses clients ou de tiers.
            </p>
            <p>
              Pour en savoir plus, vous pouvez consulter les articles concernés :
            </p>
            <ul>
              <li>
                Pour les intermédiaires d’assurance :
                <a href={URL4} target={'_blank'}> Article L.512-7 du Code des Assurances</a>
              </li>
              <li>
                Pour les intermédiaires en opérations de banque et en services de paiement
                : <a href={URL3} target={'_blank'}>Article L 519-4 du Code Monétaire et Financier</a>
              </li>
            </ul>
            <p>
              La garantie financière prend en charge les montants dus à vos clients en cas de défaillance de
              votre société et d’incapacité de votre part à transmettre les fonds reçus de ces derniers.
            </p>
            <p>
              Nous proposons une garantie financière pour les intermédiaires d’assurance
              encaissant des fonds et une garantie financière sans encaissement
              de fonds pour les intermédiaires en opérations de banque et en services de paiement.
            </p>

            <h3>Comment obtenir un devis ?</h3>
            <p>
              Après avoir complété notre questionnaire et sous réserve de répondre aux critères de souscription
              en ligne, vous pourrez télécharger immédiatement notre proposition d’assurance.
            </p>
            <p>
              La proposition vous sera également adressée par email ainsi qu’un lien permettant de
              créer votre compte afin d’avoir accès à votre espace personnel.
            </p>
            <p>
              Dans l’hypothèse où vous ne parvenez pas à finaliser votre devis pour toute raison
              : besoin d’adaptation à certaines spécificités telle que activité secondaire
              non prévue, montant de garantie souhaité plus élevé, rejet de cotation en
              ligne... nos souscripteurs sont à votre disposition
              au 01 44 70 71 00 ou par email à {this.ercproEmail()}.
            </p>

            <h3>Comment finaliser la souscription de votre contrat ?</h3>
            <p>
              Si notre proposition vous convient, connectez-vous à votre espace personnel
              pour souscrire votre contrat.
            </p>
            <p>
              Seul le paiement en ligne permet de valider votre contrat et d’obtenir immédiatement
              votre attestation d’assurance et votre contrat.
            </p>

            <h3>Quelles sont vos obligations ?</h3>
            <p>
              Notre site est un outil visant à simplifier et à faciliter la souscription de votre RC Professionnelle.
              Toutefois, certaines obligations s’imposent à vous pour bénéficier des garanties souscrites :
            </p>
            <ul>
              <li>Nous renvoyer votre contrat dûment signé</li>
              <li>
                Déclarer toute modification de votre risque auprès de notre
                équipe en écrivant à {this.ercproEmail()}
              </li>
              <li>
                Déclarer tout sinistre dans les délais légaux en complétant
                notre formulaire de déclaration en ligne via votre espace personnel
              </li>
            </ul>

            <h3>Comment gérer votre contrat d’assurance ?</h3>
            <p>
              Pendant toute la durée de votre contrat, vous pourrez, en vous connectant à votre espace personnel :
            </p>
            <ul>
              <li>télécharger vos documents contractuels</li>
              <li>demander des modifications suite à un changement de situation</li>
              <li>renouveler votre contrat</li>
              <li>déclarer un sinistre</li>
            </ul>

            <h3>Comment renouveler votre contrat ?</h3>
            <p>
              A l’approche de la date anniversaire de votre contrat, vous recevrez
              un email vous invitant à vous connecter à votre espace personnel.
            </p>

            <h3>Comment renouveler votre inscription au Registre Unique de l’ORIAS ? </h3>
            <p>
              Notre équipe transmettra directement vos données à l’ORIAS aux fins de renouvellement de l’inscription au
              Registre Unique.
            </p>
            <p>
              Pour confirmer le renouvellement de votre inscription, connectez-vous sur votre compte utilisateur de
              l’<a href="https://www.orias.fr/espace-professionnel" target="_blank">ORIAS</a> afin de régler les frais
              d’enregistrement.
            </p>

            <h3>Comment réinitialiser votre mot de passe ?</h3>
            <p>
              En cas d’oubli de votre mot de passe, cliquez
              sur «Réinitialiser votre mot de passe » dans l’espace « Connexion Client ».
            </p>
            <p>
              Suivez ensuite la procédure de réinitialisation que vous recevrez par email.
            </p>

            <h3>Comment déclarer un sinistre ?</h3>
            <ol>
              <li>Connectez-vous à votre compte en cliquant sur « Connexion client ».</li>
              <li>Cliquez sur l’onglet « Déclarer un sinistre ».</li>
              <li>Complétez le formulaire de déclaration</li>
            </ol>
            <p>
              Vous recevrez un message vous confirmant la bonne réception et le traitement de votre demande.
              Si toutefois vous ne receviez pas de réponse de notre équipe indemnisation,
              veuillez contacter {this.indemnisationEmail()} en indiquant la référence de votre contrat
            </p>

            <h3>Que faire si vous ne recevez pas nos emails ?</h3>
            <p>
              Il est possible que les emails aient été bloqués par votre messagerie. N’hésitez pas à
              vérifier votre dossier « courriers indésirables » ou SPAM et dans la négative à nous contacter au
              au 01 44 70 71 00 ou nous adresser un mail à {this.ercproEmail()}
            </p>

            <h3>Est-ce que les dispositions de l’article L. 112-2-1 sont applicables ?</h3>
            <p>
              Dans le cadre de votre activité professionnelle et en raison de l'objet de la
              garantie consistant à couvrir des conséquences résultant d'une faute professionnelle,
              le délai de renonciation de 14 jours de l'article L. 112-2-1 II du Code des
              assurances ne s’applique pas.
            </p>

            <h2>Règles de confidentialité</h2>

            <h3>Comment vos données sont-elles sécurisées ?</h3>
            <p>
              MS Amlin accorde beaucoup d’importance à ses clients et
              s’engage à protéger et à respecter leur vie privée.
            </p>
            <p>
              Nous gérerons les données à caractère personnel conformément aux principes et
              aux lois en matière de protection des données.
            </p>
            <p>
              Pour toute information concernant nos procédures et notre politique relative à
              la protection des données de nos clients,
              <a href={URL1} target={'_blank'}>visitez notre site web</a>.
            </p>

            <h3>Que fait MS Amlin de vos données ?</h3>
            <p>
              Nous avons besoin de données à caractère personnel pour fournir des services
              d'assurance de qualité et nous ne collecterons que les données nécessaires.
              Il peut s'agir d'informations personnelles telles que le nom,
              l'adresse, les coordonnées, les numéros d'identification,
              les informations financières et le profil de risque.
            </p>
            <p>
              Vous disposez à tout moment d’un droit d’accès, de modification
              et de suppression de vos informations personnelles que vous pouvez
              exercer auprès de notre Directeur de la protection des données
              à {this.dateProtectionOfficerEmail()}. MS Amlin pourrait alors ne plus être
              en mesure de gérer vos demandes.
            </p>
            <p>
              Pour toute information concernant notre politique relative à la protection
              des données de nos clients, <a href={URL1}>cliquez ici</a>.
            </p>

            <h2>
              A propos de MS Amlin
            </h2>
            <h3>Comment contacter notre équipe ?</h3>
            <p>
              Vous pouvez nous contacter par email à {this.ercproEmail()} ou par
              téléphone du lundi au vendredi de 9h à 18h au 01 44 70 71 00.
            </p>

            <h3>Qui est MS Amlin ?</h3>
            <p>
              Assureur et réassureur international de premier plan, le groupe MS Amlin est présent sur les marchés
              du Lloyd’s, au Royaume-Uni, en Europe continentale et aux Bermudes.
            </p>
            <p>
              Regroupant les activités de Mitsui Sumitomo Londres et Bermudes ainsi que les activités
              historiques du groupe Amlin, MS Amlin est spécialisé dans l’assurance des risques
              d’entreprises et dans la réassurance d’autres assureurs dans le monde entier.
              Le groupe est une filiale à part entière de la compagnie japonaise MS&AD et bénéficie
              à ce titre de la taille et de la solidité financière du huitième plus grand
              assureur non-vie au monde.
            </p>
            <p>
              Sur le marché français, MS Amlin est identifié comme un acteur alternatif aux
              compagnies traditionnelles pour proposer des solutions d’assurances sur-mesure aux
              PME / PMI, aux ETI, aux grandes entreprises et aux professionnels, en France comme à
              l’international. Les activités de souscription et d’indemnisation sont dédiées
              à l’assurance des risques Dommages aux Biens, Responsabilité Civile et Maritime et Aviation.
            </p>
            <p>
              Au sein de notre branche Responsabilité Civile, nous avons développé il y a plus de 20
              ans une expertise dédiée à la RC Professionnelle des Professions Réglementées.
            </p>
            <p>
              MS Amlin est présent à Paris, Lyon, Marseille et Strasbourg et compte environ 100 collaborateurs.
            </p>
            <p>
              Pour en savoir plus sur MS Amlin, visitez notre <a href={URL2} target="_blank">site web</a>.
            </p>

            <h3>Nos atouts</h3>
            <RCPStrengths/>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect(
  null,
  (dispatch) => ({
    actions: {
      push: bindActionCreators(push, dispatch),
      quote: bindActionCreators({ ...quoteActions }, dispatch),
    },
  }),
)(Faq);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Brochure/scenes/Faq/index.tsx